import React, { useEffect, useRef, useState } from "react";
import { X, CaretLeft, CaretRight } from "@phosphor-icons/react";
import { designImg } from "./designsApi";

// Customer view: only the image, no name/order/price. Swipe or arrows.
export const ShowMode = ({ items, start = 0, onClose }) => {
  const [i, setI] = useState(start);
  const touch = useRef(null);
  const n = items.length;
  const go = (dx) => setI((x) => (x + dx + n) % n);
  useEffect(() => {
    const k = (e) => { if (e.key === "ArrowRight") go(1); else if (e.key === "ArrowLeft") go(-1); else if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", k);
    document.documentElement.requestFullscreen?.().catch(() => {});
    return () => { window.removeEventListener("keydown", k); if (document.fullscreenElement) document.exitFullscreen?.().catch(() => {}); };
  }, [n]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!n) return null;
  const d = items[i];
  return (
    <div className="fixed inset-0 z-[100] bg-white flex items-center justify-center select-none" data-testid="show-mode"
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => { const dx = e.changedTouches[0].clientX - (touch.current ?? 0); if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); }}>
      <img key={d.id} src={designImg(d.id, false, d.rendered_at)} alt="" className="max-w-[96vw] max-h-[92vh] object-contain animate-in fade-in duration-300" data-testid="show-mode-image" />
      <button onClick={onClose} className="absolute top-3 right-3 h-10 w-10 rounded-full bg-black/70 text-white flex items-center justify-center" data-testid="show-mode-close"><X size={20} /></button>
      <button onClick={() => go(-1)} className="absolute left-2 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-black/40 text-white flex items-center justify-center" data-testid="show-mode-prev"><CaretLeft size={24} /></button>
      <button onClick={() => go(1)} className="absolute right-2 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-black/40 text-white flex items-center justify-center" data-testid="show-mode-next"><CaretRight size={24} /></button>
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 text-xs text-black/50 font-mono-num" data-testid="show-mode-count">{i + 1} / {n}</div>
    </div>
  );
};
